// beforeSend filters with no Sentry or Vite dependencies, so they can be unit-tested.

// Recaptcha times out on slow networks and blocked third-party scripts. It used to
// reject with the bare string 'Timeout'; current builds throw
// Error('reCAPTCHA Timeout (b)'). Drop both so they do not fill our quota.
export function omitGoogleRecaptchaException<T>(
  event: T,
  hint?: { originalException?: unknown }
): T | null {
  const original = hint?.originalException;
  if (original === 'Timeout') {
    return null;
  }
  const message =
    original instanceof Error ? original.message : (original as string);
  if (typeof message === 'string' && message.startsWith('reCAPTCHA Timeout')) {
    return null;
  }
  return event;
}
